<template>
	<input-form action="/json/login" @submit="$emit('submit', $event)" @loading="$emit('loading', $event)" :unsaveable="true" v-slot="props" object-key="user">
		<div class="login-content">
			<picture class="logo">
				<source srcset="/images/logo-light.svg" media="(prefers-color-scheme: dark)">
				<img src="/images/logo-dark.svg" />
			</picture>
			<p>Please enter your username and password below to sign in and manage your account.</p>
			<input-text ref="start" v-model="props.object.username" :errors="props.errors.username" label="Username/Email" prepend-icon="social/account/avatar-circle" inputmode="email"></input-text>
			<input-password v-model="props.object.password" :errors="props.errors.password" label="Password" prepend-icon="essentials/security/key"></input-password>
			<div class="actions">
				<icon-button type="submit" icon="arrows/send/in-right" :disabled="props.loading > 0">Login</icon-button>
				<a href="#" @click.prevent="$emit('forgot')">Forgot Password?</a>
			</div>
		</div>
	</input-form>
</template>

<script>
	export default {
		mounted() {
			this.$refs.start.focus();
		}
	}
</script>